import api from '../../api'

const getDefaultState = () => {
  return {
    all: [],
    alreadyRead: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getAlreadyRead: (state) => state.alreadyRead
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    return new Promise((resolve) => {
      api.getNotice(rootGetters['user/getLang'])
        .then(messages => {
          commit('setNotice', messages)
          resolve()
        })
        .catch(() => {
          commit('resetState')
          resolve()
        })
    })
  },
  updateAlreadyRead ({ commit }, id) {
    commit('updateAlreadyRead', id)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setNotice (state, messages) {
    state.all = messages
  },
  updateAlreadyRead(state, id) {
    if (!state.alreadyRead.includes(id)) {
      state.alreadyRead.push(id)
    }
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
